import React from 'react';
import classes from './Spinner.css'

const Spinner = (props) => (
    <div className={classes.loader}></div>
    );

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Layout/UI/Spinner/Spinner.js